import { render, staticRenderFns } from "./DataPrivacyConsent.vue?vue&type=template&id=53226aa4&"
import script from "./DataPrivacyConsent.vue?vue&type=script&lang=js&"
export * from "./DataPrivacyConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports